import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { Link } from "react-router-dom";

const cx = (...xs) => xs.filter(Boolean).join(" ");

export default function LegalLibrary() {
  const [docs, setDocs] = useState([]);
  const [type, setType] = useState("ALL");
  const [lang, setLang] = useState("ALL");

  useEffect(() => {
    const qy = query(collection(db, "legal_docs"), orderBy("createdAt", "desc"));
    return onSnapshot(qy, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setDocs(arr);
    });
  }, []);

  const filtered = useMemo(() => {
    return docs.filter((d) => (type === "ALL" ? true : d.type === type)).filter((d) => (lang === "ALL" ? true : d.language === lang));
  }, [docs, type, lang]);

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="max-w-6xl mx-auto px-4 py-8 space-y-4">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
          <div>
            <div className="text-xs uppercase tracking-widest text-emerald-600 font-extrabold">Society Knowledge Library</div>
            <h1 className="text-2xl font-extrabold text-slate-900">Acts • Rules • Bye-laws • Forms</h1>
            <p className="text-sm text-slate-600">Read online, download, search, and ask questions with page references.</p>
          </div>

          <div className="flex gap-2">
            <select className="border rounded-xl px-3 py-2" value={type} onChange={(e) => setType(e.target.value)}>
              <option value="ALL">All Types</option>
              <option value="ACT">Act</option>
              <option value="RULES">Rules</option>
              <option value="BYLAWS">Bye-laws</option>
              <option value="FORM">Forms</option>
            </select>

            <select className="border rounded-xl px-3 py-2" value={lang} onChange={(e) => setLang(e.target.value)}>
              <option value="ALL">All Languages</option>
              <option value="EN">English</option>
              <option value="HI">Hindi</option>
              <option value="GU">Gujarati</option>
            </select>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {filtered.map((d) => (
            <Link key={d.id} to={`/library/${d.id}`} className="bg-white rounded-2xl border shadow-sm p-4 hover:shadow-md transition">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <div className="text-xs font-bold text-slate-500">{d.type} • {d.language} • {d.year || "-"}</div>
                  <div className="text-lg font-extrabold text-slate-900">{d.title}</div>
                  <div className="text-sm text-slate-600 mt-1">{(d.tags || []).slice(0, 6).join(" • ")}</div>
                </div>
                <div className={cx("text-xs px-2 py-1 rounded-full border", d.access === "members" ? "bg-amber-50 border-amber-200 text-amber-800" : "bg-emerald-50 border-emerald-200 text-emerald-800")}>
                  {d.access === "members" ? "Members" : "Public"}
                </div>
              </div>
            </Link>
          ))}
        </div>

        {!filtered.length ? (
          <div className="text-sm text-slate-600 bg-white border rounded-2xl p-4">No documents yet. Upload from Admin panel.</div>
        ) : null}
      </div>
    </div>
  );
}
